/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TabsRouteImport } from './routes/_tabs'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as TabsIndexRouteImport } from './routes/_tabs.index'
import { Route as SourcingNewRouteImport } from './routes/sourcing.new'
import { Route as SourcingRequestIdRouteImport } from './routes/sourcing.$requestId'
import { Route as ProductsProductIdRouteImport } from './routes/products.$productId'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as ChatRoomIdRouteImport } from './routes/chat.$roomId'
import { Route as AuthSignupRouteImport } from './routes/auth.signup'
import { Route as AuthSigninRouteImport } from './routes/auth.signin'
import { Route as TabsSourcingRouteImport } from './routes/_tabs.sourcing'
import { Route as TabsMyRouteImport } from './routes/_tabs.my'
import { Route as TabsChatRouteImport } from './routes/_tabs.chat'

const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsRoute = TabsRouteImport.update({
  id: '/_tabs',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsIndexRoute = TabsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TabsRoute,
} as any)
const SourcingNewRoute = SourcingNewRouteImport.update({
  id: '/sourcing/new',
  path: '/sourcing/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SourcingRequestIdRoute = SourcingRequestIdRouteImport.update({
  id: '/sourcing/$requestId',
  path: '/sourcing/$requestId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoomIdRoute = ChatRoomIdRouteImport.update({
  id: '/chat/$roomId',
  path: '/chat/$roomId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsSourcingRoute = TabsSourcingRouteImport.update({
  id: '/sourcing',
  path: '/sourcing',
  getParentRoute: () => TabsRoute,
} as any)
const TabsMyRoute = TabsMyRouteImport.update({
  id: '/my',
  path: '/my',
  getParentRoute: () => TabsRoute,
} as any)
const TabsChatRoute = TabsChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => TabsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof TabsIndexRoute
  '/search': typeof SearchRoute
  '/chat': typeof TabsChatRoute
  '/my': typeof TabsMyRoute
  '/sourcing': typeof TabsSourcingRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/chat/$roomId': typeof ChatRoomIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/sourcing/$requestId': typeof SourcingRequestIdRoute
  '/sourcing/new': typeof SourcingNewRoute
  '/orders/': typeof OrdersIndexRoute
}
export interface FileRoutesByTo {
  '/search': typeof SearchRoute
  '/chat': typeof TabsChatRoute
  '/my': typeof TabsMyRoute
  '/sourcing': typeof TabsSourcingRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/chat/$roomId': typeof ChatRoomIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/sourcing/$requestId': typeof SourcingRequestIdRoute
  '/sourcing/new': typeof SourcingNewRoute
  '/': typeof TabsIndexRoute
  '/orders': typeof OrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_tabs': typeof TabsRouteWithChildren
  '/search': typeof SearchRoute
  '/_tabs/chat': typeof TabsChatRoute
  '/_tabs/my': typeof TabsMyRoute
  '/_tabs/sourcing': typeof TabsSourcingRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/chat/$roomId': typeof ChatRoomIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/sourcing/$requestId': typeof SourcingRequestIdRoute
  '/sourcing/new': typeof SourcingNewRoute
  '/_tabs/': typeof TabsIndexRoute
  '/orders/': typeof OrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/search'
    | '/chat'
    | '/my'
    | '/sourcing'
    | '/auth/signin'
    | '/auth/signup'
    | '/chat/$roomId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/sourcing/$requestId'
    | '/sourcing/new'
    | '/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/search'
    | '/chat'
    | '/my'
    | '/sourcing'
    | '/auth/signin'
    | '/auth/signup'
    | '/chat/$roomId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/sourcing/$requestId'
    | '/sourcing/new'
    | '/'
    | '/orders'
  id:
    | '__root__'
    | '/_tabs'
    | '/search'
    | '/_tabs/chat'
    | '/_tabs/my'
    | '/_tabs/sourcing'
    | '/auth/signin'
    | '/auth/signup'
    | '/chat/$roomId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/sourcing/$requestId'
    | '/sourcing/new'
    | '/_tabs/'
    | '/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  TabsRoute: typeof TabsRouteWithChildren
  SearchRoute: typeof SearchRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  ChatRoomIdRoute: typeof ChatRoomIdRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  SourcingRequestIdRoute: typeof SourcingRequestIdRoute
  SourcingNewRoute: typeof SourcingNewRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs': {
      id: '/_tabs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof TabsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs/': {
      id: '/_tabs/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof TabsIndexRouteImport
      parentRoute: typeof TabsRoute
    }
    '/sourcing/new': {
      id: '/sourcing/new'
      path: '/sourcing/new'
      fullPath: '/sourcing/new'
      preLoaderRoute: typeof SourcingNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sourcing/$requestId': {
      id: '/sourcing/$requestId'
      path: '/sourcing/$requestId'
      fullPath: '/sourcing/$requestId'
      preLoaderRoute: typeof SourcingRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$roomId': {
      id: '/chat/$roomId'
      path: '/chat/$roomId'
      fullPath: '/chat/$roomId'
      preLoaderRoute: typeof ChatRoomIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs/sourcing': {
      id: '/_tabs/sourcing'
      path: '/sourcing'
      fullPath: '/sourcing'
      preLoaderRoute: typeof TabsSourcingRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/my': {
      id: '/_tabs/my'
      path: '/my'
      fullPath: '/my'
      preLoaderRoute: typeof TabsMyRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/chat': {
      id: '/_tabs/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof TabsChatRouteImport
      parentRoute: typeof TabsRoute
    }
  }
}

interface TabsRouteChildren {
  TabsChatRoute: typeof TabsChatRoute
  TabsMyRoute: typeof TabsMyRoute
  TabsSourcingRoute: typeof TabsSourcingRoute
  TabsIndexRoute: typeof TabsIndexRoute
}

const TabsRouteChildren: TabsRouteChildren = {
  TabsChatRoute: TabsChatRoute,
  TabsMyRoute: TabsMyRoute,
  TabsSourcingRoute: TabsSourcingRoute,
  TabsIndexRoute: TabsIndexRoute,
}

const TabsRouteWithChildren = TabsRoute._addFileChildren(TabsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  TabsRoute: TabsRouteWithChildren,
  SearchRoute: SearchRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  ChatRoomIdRoute: ChatRoomIdRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  ProductsProductIdRoute: ProductsProductIdRoute,
  SourcingRequestIdRoute: SourcingRequestIdRoute,
  SourcingNewRoute: SourcingNewRoute,
  OrdersIndexRoute: OrdersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
